import { celebrityInfo } from '@/mocks/site';
import { Link } from 'react-router-dom';

export default function BiographySection() {
  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
          <div className="lg:col-span-2">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20female%20celebrity%20portrait%20with%20warm%20golden%20lighting%2C%20soft%20cream%20silk%20dress%2C%20minimalist%20studio%20background%2C%20professional%20editorial%20photography%2C%20graceful%20and%20sophisticated%20mood&width=600&height=800&seq=anri-portrait-home&orientation=portrait"
                alt="冲田杏梨"
                className="w-full h-auto object-cover rounded-lg"
              />
            </div>
          </div>
          <div className="lg:col-span-3 flex flex-col justify-center">
            <span className="text-xs font-medium text-primary-500 uppercase tracking-wider mb-2">
              个人简介
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-[family-name:var(--font-heading)] mb-4">
              关于 {celebrityInfo.name}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {celebrityInfo.bio}
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {celebrityInfo.hobbies.map((hobby) => (
                <span
                  key={hobby}
                  className="px-3 py-1 rounded-full text-xs bg-accent-100 text-accent-700 border border-accent-200/70"
                >
                  {hobby}
                </span>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/profile"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
              >
                <i className="ri-user-heart-line"></i>
                完整个人资料
              </Link>
              <Link
                to="/about"
                className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap inline-flex items-center justify-center gap-2 cursor-pointer"
              >
                <i className="ri-information-line"></i>
                关于本站
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}